const EverythingModule = {
	comment: {
		type: "comment",
		label: "",
		properties: {
			content: "<h1>Hello World</h1><small>Small</small>",
			alertStyle: "warning",
		},
	},
	oauthPicker: {
		type: "oauthPicker",
		integrationTypes: ["@hillsong-technology/verris-module-formstack-integration"],
		label: "",
		initialValue: {},
	},
	formstackData: {
		type: "formstackFormPicker",
		label: "Formstack",
		helperText: "yes ok help",
		initialValue: {},
	},
	checkBox: {
		type: "checkbox",
		label: "CheckBox",
		isRequired: true,
		validationRegex: "",
		helperText: "Helper Text",
		values: [
			{
				text: "string",
				value: "string",
			},
		],
		initialValue: false,
		properties: {},
		dependencyKey: "",
		dependencyValue: "",
	},
	checkBoxTrue: {
		type: "checkbox",
		label: "CheckBox True",
		isRequired: true,
		validationRegex: "",
		helperText: "Helper Text",
		values: [
			{
				text: "string",
				value: "string",
			},
		],
		initialValue: true,
		properties: {},
		dependencyKey: "",
		dependencyValue: "",
	},
	dateTime: {
		type: "dateTime",
		label: "Date Time",
		isRequired: true,
		helperText: "Date Time Helper Text",
		initialValue: "Now",
		dependencyKey: "checkBoxTrue",
		dependencyValue: true,
	},
	select: {
		type: "select",
		label: "Select List (Toggle Field)",
		isRequired: true,
		helperText: "Select List Helper Text",
		values: [
			{
				text: "Hide",
				value: "Hide",
			},
			{
				text: "Show",
				value: "Show",
			},
		],
		initialValue: "Hide",
	},
	selectTwo: {
		type: "select",
		label: "Select List (Toggled Field)",
		isRequired: true,
		helperText: "Select List Helper Text",
		values: [
			{
				text: "Hide",
				value: "Hide",
			},
			{
				text: "Show",
				value: "Show",
			},
		],
		initialValue: "Hide",
		dependencyKey: "select",
		dependencyValue: "Show",
	},
	mediaImage: {
		type: "mediaImage",
		label: "Media Image",
		isRequired: true,
		helperText: "Media Image Helper Text",
		initialValue:
			"https://images.unsplash.com/photo-1543539748-a4bf17a68a8a?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=fa19fa0ae64e6770cb068626f6a497cc&auto=format&fit=crop&w=582&q=80",
	},
	iconPicker: {
		type: "iconPicker",
		label: "Icon Picker",
		isRequired: true,
		helperText: "Icon Helper Text",
		initialValue: {
			font: "FontAwesome5_Pro_Light",
			icon: "f6cf",
		},
	},
	pagePicker: {
		type: "pagePicker",
		label: "Page Picker",
		isRequired: true,
		helperText: "Page Picker Helper Text",
		initialValue: "",
	},
	pageOrUrlPicker: {
		type: "pageOrUrlPicker",
		label: "Page Or Url Picker",
		isRequired: true,
		helperText: "Page Or Url Picker Helper Text",
		initialValue: "",
	},
	text: {
		type: "text",
		label: "Basic Text Input",
		isRequired: true,
		helperText: "Text Helper Text",
		initialValue: "Hello World",
	},
	multiline: {
		type: "multilineText",
		label: "Basic Multiline Text Input",
		isRequired: true,
		helperText: "Multiline Text Helper Text",
		initialValue: "Hello World\n\nHello World",
	},
	formattedText: {
		type: "formattedText",
		label: "Formatted Multiline Text Input",
		isRequired: true,
		helperText: "Formatted Text Helper Text",
		initialValue: "<u>Hello World</u>\n\nHello World",
	},
	html: {
		type: "html",
		label: "HTML Text Input",
		isRequired: true,
		helperText: "HTML Text Helper Text",
		initialValue: "<u>Hello World</u>\n\n<b>Hello World</b>",
	},
	videoUrl: {
		type: "videoUrl",
		label: "Video Input",
		isRequired: true,
		helperText: "Video Helper Text",
		initialValue: "https://www.youtube.com/watch?v=1UnIDL-eHOs",
	},
	audioUrl: {
		type: "audioUrl",
		label: "Audio Input",
		isRequired: true,
		helperText: "Audio Helper Text",
		initialValue: "https://soundcloud.com/billieeilish/hotline-bling",
	},
	url: {
		type: "url",
		label: "Url Input",
		isRequired: true,
		helperText: "Url Helper Text",
		initialValue: "https://soundcloud.com/plasimusic/now-and-then",
	},
	textArray: {
		type: "textArray",
		label: "Text Array",
		isRequired: true,
		helperText: "Text Array Helper Text",
		initialValue: [""],
	},
	textAndValueArray: {
		type: "textAndValueArray",
		label: "Text And Value Array",
		isRequired: true,
		helperText: "Text Array Helper Text",
		initialValue: [{ text: "Text?", value: "Value!" }],
		values: [
			{
				text: "Text Input",
				value: "Value Input",
			},
		],
	},
	topicPicker: {
		type: "topicPicker",
		label: "Topic Picker",
		isRequired: false,
		helperText: "Topic Picker Helper Text",
		initialValue: [],
	},
	topicsPicker: {
		type: "topicsPicker",
		label: "Topics Picker",
		isRequired: false,
		helperText: "Topics Picker Helper Text",
		initialValue: [],
	},
	colorPicker: {
		type: "colorPicker",
		label: "Color Picker",
		isRequired: true,
		helperText: "Color Picker Helper Text",
		initialValue: "rgba(255,255,255,0)",
	},
	postTagPicker: {
		type: "postTagPicker",
		label: "Post Tag Picker",
		isRequired: false,
		helperText: "Post Tag Picker Helper Text",
		initialValue: [],
	},
	sessionPicker: {
		type: "sessionPicker",
		label: "Session Picker",
		isRequired: false,
		helperText: "Session Picker Helper Text",
		initialValue: [],
	},
	sessionTagPicker: {
		type: "sessionTagPicker",
		label: "Session Tag Picker",
		isRequired: false,
		helperText: "Session Tag Picker Helper Text",
		initialValue: [],
	},
	timezonePicker: {
		type: "timezonePicker",
		label: "Timezone Picker",
		isRequired: false,
		helperText: "Timezone Picker Helper Text",
		initialValue: "",
	},
	collection: {
		type: "collection",
		label: "Collection",
		isRequired: true,
		items: {
			maximum: 3,
			minimum: 1,
			properties: {
				name: {
					type: "text",
					label: "Name of the collection item",
					isRequired: true,
					initialValue: "Name",
				},
			},
		},
	},
	group: {
		type: "group",
		label: "Group Label",
		items: {
			properties: {
				something: {
					type: "text",
					label: "A field",
					isRequired: false,
					initialValue: "stuff",
				},
				dateTime: {
					type: "dateTime",
					label: "Date Time",
					isRequired: true,
					helperText: "Date Time Helper Text",
					initialValue: "Now",
				},
			},
		},
	},
	brushfireApiKey: {
		type: "text",
		label: "Brushfire API key",
		isRequired: true,
		values: [],
		initialValue: "ap1k3y",
		properties: {},
	},
	brushfireFieldPicker: {
		type: "brushfireFieldPicker",
		label: "Brushfire Field Picker",
		isRequired: false,
		values: [],
		initialValue: [],
	},
	brushfireSessionMapper: {
		type: "brushfireSessionMapper",
		label: "Brushfire Session Mapper",
		isRequired: false,
		values: [],
		initialValue: [],
	},
	contentCollection: {
		type: "collection",
		label: "Content Collection",
		isRequired: true,
		items: {
			properties: {
				addSpacingAbove: {
					type: "checkbox",
					label: "Add Spacing Above",
				},
				addSpacingBelow: {
					type: "checkbox",
					label: "Add Spacing Below",
				},
				type: {
					type: "select",
					label: "Content Type",
					isRequired: true,
					values: [
						{
							text: "Image",
							value: "Image",
						},
						{
							text: "Text",
							value: "Text",
						},
						{
							text: "Button",
							value: "Button",
						},
					],
					initialValue: "Image",
				},
				imageURL: {
					type: "mediaImage",
					label: "Upload Image",
					dependencyKey: "type",
					dependencyValue: "Image",
				},
				content: {
					type: "html",
					label: "Content to Display",
					dependencyKey: "type",
					dependencyValue: "Text",
				},
				label: {
					type: "text",
					label: "Button Label",
					initialValue: "",
					isRequired: true,
					dependencyKey: "type",
					dependencyValue: "Button",
				},
				link: {
					type: "pageOrUrlPicker",
					label: "Page to Link",
					initialValue: "",
					dependencyKey: "type",
					dependencyValue: "Button",
				},
			},
		},
	},
};
export default EverythingModule;
